import { StepsItem } from './Item';
import { StepsRoot } from './Root';

export type { StepsRootProps } from './Root';
export type { StepsItemProps } from './Item';

export const Steps = {
  Root: StepsRoot,
  Item: StepsItem,
};
